// import React from 'react';
import {Button} from 'semantic-ui-react';
import styled from 'styled-components';

const BaseButton = styled(Button)`
  &&& {
    border-radius: 20px;
    border: solid 1px #ef5350;

    height: ${props => props.size === 'large' && '56px'};
    padding: ${props => props.size === 'large' && '0 30px'};
    border-radius: ${props => props.size === 'large' && '28px'};
  }
`;

const BasicButton = styled(BaseButton)`
  &&& {
    background-color: #fff;
    color: #ef5350 !important;

    &:hover {
      color: #ef5350 !important;
      background-color: #f9f0f0 !important;
    }
  }
`;

const PositiveButton = styled(BaseButton)`
  &&& {
    background-color: #ef5350;
    color: white !important;

    &:hover,
    &:focus {
      background-color: #f16c6a;
    }
  }
`;

export {BasicButton, PositiveButton};
